/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SSOImageRepositoryResponse } from "../types/SSOImageRepositoryResponse.ts";
import { ESSOCategorySchema } from "./ESSOCategorySchema.ts";
import { ESSOImageStatusSchema } from "./ESSOImageStatusSchema.ts";
import { SSOImageLangRepositoryResponseSchema } from "./SSOImageLangRepositoryResponseSchema.ts";

export const SSOImageRepositoryResponseSchema = z.object({
  id: z.optional(z.number().int().describe("ID da imagem SSO.")),
  title: z.string().describe("Título da imagem SSO.").nullish(),
  categoryId: z.optional(
    z
      .lazy(() => ESSOCategorySchema)
      .describe(
        "1 = Agribusiness | 2 = DataTech | 3 = Finance | 4 = Education | 5 = MarketingAndSales | 6 = Business | 7 = Law | 8 = HumanResources | 9 = ProjectManagement | 10 = General | ",
      ),
  ),
  dateStart: z
    .string()
    .datetime()
    .describe("Data de início da exibição da imagem SSO. Opcional.")
    .nullish(),
  dateEnd: z
    .string()
    .datetime()
    .describe("Data de término da exibição da imagem SSO. Opcional.")
    .nullish(),
  status: z.optional(
    z.lazy(() => ESSOImageStatusSchema).describe("1 = Draft | 2 = Publish | "),
  ),
  ssoImageLangs: z
    .array(z.lazy(() => SSOImageLangRepositoryResponseSchema))
    .describe(
      "Lista de variações de idioma e viewport associadas à imagem SSO.",
    )
    .nullish(),
}) as unknown as ToZod<SSOImageRepositoryResponse>;
